import { BehaviorCategory } from "./behavior-category.model";
import { Category } from "../../shared/models/category.model";
import { CategorySummary } from "./category-summary.model";

export class GradingPeriod {
    Id: number;
    Code: string;
    Description: string;
    StartDate: Date;
    EndDate: Date;
    AutoUnlockStartDate: Date;
    AutoUnlockEndDate: Date;
    Order: number;
    PostingDeadline: Date;
    PostingTerm: boolean;
    ReportingTerm: boolean;
    IsLocked: boolean;
    IsCalculated: boolean;
    DataBucket_ID: number;
    UsePostingDeadline: boolean;
    BucketNo: string;
    BucketType: string;
    ForStandards: boolean;
    BehaviorAttached: boolean;
    Weight: number;

    // Non DTO Fields
    isSelected: boolean;
    rcgStandardsIsSelected: boolean;
    studentViewTraditionalSelected: boolean;
    studentViewStandardSelected: boolean;
    studentViewBehaviorSelected: boolean;
    reportingIndex: number;
    standardIndex: number;
    HeaderDate: string;
    headerLabel: string;
    BehaviorCategories: BehaviorCategory[];
    StartDateFormatted: string;
    EndDateFormatted: string;
    currentPeriod: boolean;
    copyScore: string;
    copyCategory: boolean;
    exceedWeight: string;
    analysisCategories: Category[];
    categorySummary: CategorySummary[];
    PostingDeadlineType: Date;
}